import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
import Header from '../master_root/header';
//page links  
export default function Feesandcharges() {
  return (
           <div >
       <Header /> 
     <div className='app_header_height'></div>
    <div className="container_roots">
    <Helmet>
        <title>EditorTask - Fees & Charges</title>
        <meta name="description" content="Understand how EditorTask fees work. Learn about platform charges for job posting, hiring freelancers, and withdrawing earnings." />
        <meta name="keywords" content="editor task fees, service charges, freelance commission, withdrawal charges, job posting cost, EditorTask pricing" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="EditorTask - Transparent Fees & Charges" />
        <meta property="og:description" content="Transparent fee policy for job providers and creative professionals. Know what you pay, and when." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/fees-and-charges" />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
      </Helmet>
      <div className="container_size">
        <h2 className="contact-title">Fees & Charges</h2>

        <div className="info-section">
          <h2>For Job Providers</h2>
          <ul>
            <li><b>Job Posting:</b> Free – You can post unlimited job tasks at no cost.</li>
            <li><b>Featured Listing (Optional):</b> ₹499 – Highlight your task for better visibility.</li>
            <li><b>Commission on Hire:</b> 5% of the total task budget is charged when a job is accepted.</li>
          </ul>
        </div>

        <div className="info-section">
          <h2>For Freelancers & Creative Talent</h2>
          <ul>
            <li><b>Creating a Profile:</b> 100% Free – Showcase your work, skills, and portfolio.</li>
            <li><b>Service Fee:</b> 10% commission on the amount earned per task.</li>
            <li><b>Withdrawal Fee:</b> ₹50 flat fee per withdrawal to bank account/UPI (India).</li>
          </ul>
        </div>

        <div className="info-section">
          <h2>Refunds & Disputes</h2>
          <ul>
            <li>EditorTask offers a secure escrow system for task payments.</li>
            <li>Refunds are processed if a task is cancelled or unfulfilled per our <a href="/terms">terms and policies</a>.</li>
          </ul>
        </div>

        <div className="info-section">
          <h2>Taxes</h2>
          <ul>
            <li>All fees mentioned are inclusive of applicable GST (India).</li>
            <li>Invoicing for both clients and freelancers will include tax breakdowns.</li>
          </ul>
        </div>

        <div className="info-section">
          <h2>Need Help?</h2>
          <p>If you have questions about our pricing, feel free to <a href="/contact">contact us</a>.</p>
        </div>
      </div>
    </div>
</div>
    );
}
